import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getDagLogs } from "../../services/logs";
import { buildDagLogFilterParams } from "../../utils/helpers";

const useDagLogs = () => {
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 10,
  });
  const [filterModel, setFilterModel] = useState({ items: [] });

  useEffect(() => {
    let isActive = true;

    const fetchData = async () => {
      setLoading(true);
      try {
        const filters = buildDagLogFilterParams(filterModel);
        const response = await getDagLogs({
          page: pagination.page + 1,
          limit: pagination.pageSize,
          ...filters,
        });

        if (!isActive) return;

        setRows(response.data);
        setRowCount(response.total);
      } catch (fetchError) {
        if (!isActive) return;
        toast.error("Error al cargar los logs de DAGs");
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isActive = false;
    };
  }, [pagination, filterModel]);

  return {
    rows,
    rowCount,
    loading,
    pagination,
    setPagination,
    filterModel,
    setFilterModel,
  };
};

export default useDagLogs;
